module.exports = __webpack_public_path__ + "img/style_swiper_01_active.82eaa820.png";